// IE11 Polyfills
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import Vue from 'vue';
import App from './App.vue';
import store from './store';
import './assets/styles/index.css';

Vue.config.productionTip = false;

// Initialize IMQA - This will be controlled by the app UI
window.initIMQA = function(config) {
  if (window.IMQA) {
    try {
      window.IMQA.init(config);
      return true;
    } catch (error) {
      console.error('IMQA initialization error:', error);
      return false;
    }
  } else {
    console.error('IMQA is not available');
    return false;
  }
};

new Vue({
  store,
  render: h => h(App)
}).$mount('#app');